<template>
  <div class="row">
    <div v-if="showEditForm" class="col-12">
      <create-car-form :edit-mode="true" :car="toolGroup" @close="showEditForm = false" @saved="onCarSaved"></create-car-form>
    </div>
    <div class="col-md-4">
      <card>
        <h2>{{ toolGroup.name }}</h2>
        <img v-if="toolGroup.toolGroupImageBytes" class="img-fluid shadow border-radius-lg " :src="'data:image/png;base64,' + toolGroup.toolGroupImageBytes" alt="tool alt text" />
        <h3 v-if="licencePlate">{{ licencePlate }}</h3>
        <h4 v-if="reservedBy"><b>{{$t('cars.reservedBy')}}:</b> {{ reservedBy }}</h4>
        <div v-if="vehicleDetails.length > 0" class="my-3">
          <div v-for="detail in vehicleDetails" :key="detail.label" class="d-flex justify-content-between border-bottom py-1">
            <span class="text-secondary me-3">{{ detail.label }}</span>
            <span class="text-end">{{ detail.value }}</span>
          </div>
        </div>
        <h6 v-if="enableGPS && toolGroup.deviceId">
          <b>{{ $t('tools.gpsDevice') }}:</b>
          {{ toolGroup.deviceTypeName }} {{ toolGroup.deviceId }}
          <span v-if="toolGroup.deviceBatteryPct != null">
            <i class="fas fa-battery-full ms-2 me-1" :style="{ color: batteryColor }"></i>
            {{ Math.round(toolGroup.deviceBatteryPct) }}%
          </span>
          <device-status-badge class="ms-2" :last-contact="toolGroup.deviceLastContact" />
        </h6>
        <!-- <h4 v-if="lastService"><b>{{$t('cars.lastService')}}:</b> {{ lastService }}</h4>
        <h4 v-if="comment"><b>{{$t('cars.comment')}}:</b> {{ comment }}</h4> -->
        <div class="row">
          <div v-if="canEditCar" class="col-md-12">
            <ul class="navbar-nav d-flex justify-content-end ">
              <li class="nav-item dropdown w-100">
                <a class="nav-link dropdown-toggle d-flex align-items-center justify-content-center py-2 btn mb-0 btn-dark btn-block" href="#" role="button"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  {{ $t('common.actions') }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li v-if="isAdmin && !isMobile">
                    <a class="dropdown-item black d-flex align-items-center" @click="printQRCode">
                      <i class="material-icons black me-2">cloud_download</i>
                      {{ $t('tools.printQR') }}
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item black d-flex align-items-center" @click="openLastServiceModal">
                      <i class="material-icons black me-2">edit</i>
                      {{ $t('cars.setServiceDetails') }}
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item black d-flex align-items-center" @click="openEditForm">
                      <i class="material-icons black me-2">tune</i>
                      {{ $t('cars.editCar') }}
                    </a>
                  </li>
                  <li v-if="isAdmin && reservedBy">
                    <a class="dropdown-item red d-flex align-items-center" @click="unreserve">
                      <i class="material-icons red me-2">clear</i>
                      {{ $t('cars.unreserve') }}
                    </a>
                  </li>
                  <li v-if="isAdmin && !reservedBy && !showReserveTable">
                    <a class="dropdown-item green d-flex align-items-center" @click="openReserveUserTable">
                      <i class="material-icons green me-2">person</i>
                      {{ $t('cars.assignToUser') }}
                    </a>
                  </li>
                  <li v-if="isAdmin && enableGPS">
                    <a class="dropdown-item black d-flex align-items-center" @click="openGpsDeviceModal">
                      <i class="material-icons black me-2">sensors</i>
                      {{ $t('cars.manageGpsDevice') }}
                    </a>
                  </li>
                  <li v-if="isAdmin && enableGPS && toolGroup.deviceId">
                    <a class="dropdown-item black d-flex align-items-center" @click="goToGeoTraces">
                      <i class="material-icons black me-2">place</i>
                      {{ $t('tools.viewGeoTraces') }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </card>
      <modal v-model:show="showLastServiceModal" class="white-content">
        <h3 class="card-title">{{$t('cars.setServiceDetails')}}</h3>
        <div class="row">
          <div class="col-12">
            <label class="col-form-label">{{$t('cars.lastService')}}</label>
            <base-input>
              <el-date-picker
                v-model="lastService"
                type="date"
                format="DD/MM/YYYY"
                value-format="YYYY-MM-DD"
                :placeholder="$t('cars.lastService')"
              >
              </el-date-picker>
            </base-input>
            <material-input-field
              id="comment"
              v-model="comment"
              :label="`${$t('cars.comment')} *`"
              :placeholder="$t('cars.comment')"
              name="comment"
              variant="static"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button color="dark" type="standard" fill @click="saveLastServiceDetails">{{$t('common.submit')}}</material-button>
          </div>
        </div>
      </modal>
  
      <modal v-model:show="showGpsDeviceModal" class="white-content">
        <h3 class="card-title">{{ $t('cars.manageGpsDevice') }}</h3>
        <div class="row">
          <div class="col-12 mb-3">
            <material-input-field
              id="carDeviceId"
              v-model="deviceIdInput"
              :label="$t('tools.deviceId')"
              :placeholder="$t('tools.deviceId')"
              name="carDeviceId"
              variant="static"
            />
          </div>
          <div class="col-12 mb-3">
            <label>{{ $t('tools.deviceType') }}</label>
            <el-select
              v-model="deviceTypeOption"
              filterable
              clearable
              size="large"
              :placeholder="$t('tools.selectDeviceType')"
              class="w-100"
            >
              <el-option
                v-for="item in deviceTypeOptions"
                :key="item.id"
                :value="item.id"
                :label="item.type"
              />
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button color="dark" type="standard" fill @click="saveGpsDevice">
              {{ $t('common.submit') }}
            </material-button>
          </div>
        </div>
      </modal>
  
      <div class="row">
        <user-reserve-table v-if="showReserveTable" :tool-group-id="toolGroupId" @close="closeReserveUserTable" @refresh-data="fetchData"></user-reserve-table>
      </div>
      </div>
      <div class="col-md-8">
        <card :title="$t('cars.serviceHistory')" class="stretch-card">
          <div class="table-responsive">
            <el-table :data="serviceHistory">
              <el-table-column
                v-for="column in filteredServiceHistoryColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
            </el-table>
          </div>
        </card>
      </div>
      <div class="col-12">
        <add-tool-table v-if="showAddToolTable" :tool-group-id="toolGroupId" @close="closeAddToolTable" @refresh-data="fetchData"></add-tool-table>
        <car-qr-scanner ref="carQrScanner" @decoded="onQrDecoded"></car-qr-scanner>
        <card
          :title="$t('cars.toolsInCar')"
          :on-add-object="canManageCarTools ? openAddToolTable : null"
          :on-custom-method="canManageCarTools && enableQRScanForCarToolAssignment && isMobile ? openCarScanner : null"
          custom-method-icon="photo_camera"
        >
          <div>
            <!-- Desktop Table -->
            <el-table v-if="!isMobile" :data="tools" :row-class-name="tableRowClassName" @row-click="navigateToTool" class="clickable-rows">
              <el-table-column
                prop="toolImageThumbnailBytes"
                :label="$t('common.image')"
                width="80"
              >
                <template #default="{ row }">
                  <img :src="'data:image/png;base64,' + row.toolImageThumbnailBytes" class="img-fluid shadow" alt="Tool Image" />
                </template>
              </el-table-column>
              <el-table-column
                v-for="column in filteredTableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
                <template #default="{ row }">
                  <div>
                    {{ row[column.prop] }}
                      <br />
                      <a v-if="column.prop === 'name' && row.toolReservations[0]" class="clickable-link" @click="navigateToUserProfile(row.toolReservations[0].user.id)">
                        {{ row.toolReservations[0].user.firstName}}
                      </a>
                  </div>
                </template>
              </el-table-column>
  
              <el-table-column v-if="canManageCarTools" width="60" align="right" label="">
                <template #default="{ row }">
                  <i class="material-icons remove-tool-icon" @click.stop="removeTool(row.id)">close</i>
                </template>
              </el-table-column>
            </el-table>
            <!-- Mobile Table -->
            <el-table v-else :data="tools" :row-class-name="tableRowClassName" @row-click="navigateToTool" class="clickable-rows">
              <el-table-column :label="$t('common.image')">
                <template #default="{ row }">
                  <img :src="'data:image/png;base64,' + row.toolImageThumbnailBytes" class="img-fluid shadow" alt="Tool Image" />
                </template>
              </el-table-column>
              <el-table-column :label="$t('common.info')" min-width="190">
                <template #default="{ row }">
                  <div>
                    <div><strong>{{$t('common.customerToolId')}}:</strong> {{ row.customerToolId }}</div>
                    <div><strong>{{$t('common.name')}}:</strong> {{ row.name }}</div>
                    <div><strong>{{$t('tools.brand')}}:</strong> {{ row.brandName }}</div>
                    <div v-if="row.toolReservations[0]">
                      <strong>{{$t('tools.reservedBy')}}:</strong>
                      <a class="clickable-link" @click="navigateToUserProfile(row.toolReservations[0].user.id)">
                        {{ row.toolReservations[0].user.firstName}}
                      </a>
                    </div>
  
                    <div v-if="canManageCarTools">
                      <i class="material-icons remove-tool-icon" @click.stop="removeTool(row.id)">close</i>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
  
          <div v-show="false" class="row">
            <card type="toolqr">
              <p class="card-text"></p>
              <div class="qr-print-container">
                <div >
                  <img src=img/sidebar-header-tolspor2.png alt="app-logo" class="print-logo"/>
                </div>
                <qrcode-vue
                  ref="printqrcode"
                  render-as="svg"
                  :value="qrValue"
                  :size="qrPrintSize"
                  level="H"
                  background="#ffffff"
                  foreground="#000000"
                >
                </qrcode-vue>
                <h3>{{ toolGroup.name }}</h3>
              </div>
            </card>
          </div>
  
        </card>
      </div>
  </div>
  </template>
  
  <script>
  import api from "../../services/api";  // Import your API service
  import AddToolTable from "./AddToolTable";
  import UserReserveTable from "./UserReserveTable";
  import CreateCarForm from "./CreateCarForm";
  import CarQrScanner from "../../components/QRScanner/CarQrScanner.vue";
  import { ElTable, ElTableColumn, ElDatePicker, ElSelect, ElOption } from 'element-plus';
  import { getCustomerConfig } from '../Settings/customerConfigHelper';
  import { jwtDecode } from "jwt-decode";
  import Cookies from 'js-cookie';
  import swal from 'sweetalert2';
  import config from "@/config";
  import QrcodeVue from 'qrcode.vue';  // Import QrcodeVue from qrcode.vue
  import Modal from '../../components/Modals/Modal.vue';
  import Card from "../../components/Card.vue";
  import BaseInput from "../../components/BaseInput.vue";
  import MaterialButton from "../../components/MaterialButton.vue";
  import MaterialInputField from "../../components/MaterialInputField.vue";
  import DeviceStatusBadge from "../../components/DeviceStatusBadge.vue";
  import {
    CAR_TOOL_GROUP_TYPE_ID, VEHICLE_CATEGORIES, FUEL_TYPES, CUSTOM_FIELD_TYPE, labelKeyFor, formatDate, customFieldValue
  } from './carHelper';

  export default {
  components: {
      QrcodeVue,
      AddToolTable,
      UserReserveTable,
      CreateCarForm,
      CarQrScanner,
      ElTable,
      ElTableColumn,
      ElDatePicker,
      ElSelect,
      ElOption,
      Modal,
      Card,
      BaseInput,
      MaterialButton,
      MaterialInputField,
      DeviceStatusBadge
  },
  data() {
      return {
      qrDisplaySize: 128,
      qrPrintSize: 256,
      toolGroup: {},
      tools:[],
      serviceHistory:[],
      showAddToolTable: false,
      showReserveTable: false,
      toolGroupId: 0,
      reservedBy: '',
      licencePlate:'',
      lastService: '',
      comment: '',
      showLastServiceModal: false,
      showGpsDeviceModal: false,
      enableGPS: false,
      deviceIdInput: '',
      deviceTypeOption: null,
      deviceTypeOptions: [],
      customFields: [],
      serviceHistoryColumns: [
          { prop: 'date', label: this.$t('common.date'), minWidth: 120 },
          { prop: 'comment', label: this.$t('cars.comment'), minWidth: 200 },
        ],
      tableColumns: [
        {
          prop: 'customerToolId',
          label: this.$t('common.customerToolId'),
          minWidth: 60
        },
        {
          prop: 'name',
          label: this.$t('common.name'),
          minWidth: 150
        },
        {
          prop: 'description',
          label: this.$t('common.description'),
          minWidth: 140
        },
        {
          prop: 'brandName',
          label: this.$t('tools.brand'),
          minWidth: 150
        }
      ],
        isMobile: window.innerWidth <= 1024,
        userRole: '',
        currentUserId: '',
        enableQRScanForCarToolAssignment: false,
      allowUsersToAddRemoveCarTools: false,
      allowAssignedUsersToEditVehicles: false,
      showEditForm: false,
    };
  },
  computed: {
    canManageCarTools() {
      return this.userRole !== 'User' || this.allowUsersToAddRemoveCarTools;
    },
    isAdmin() {
      return this.userRole !== 'User';
    },
    // Users may register service/inspection and edit a car assigned to them when the customer allows it
    canEditCar() {
      if (this.isAdmin) return true;
      return this.allowAssignedUsersToEditVehicles && (this.toolGroup.toolGroupReservations || [])
        .some(r => r.isReserved && !r.externalUser && r.user && r.user.id === this.currentUserId);
    },
    batteryColor() {
      const pct = this.toolGroup?.deviceBatteryPct;
      if (pct == null) return '';
      if (pct <= 10) return '#dc3545';
      if (pct <= 39) return '#ffc107';
      return '#28a745';
    },
    qrValue() {
      // Combine the base URL with the tool ID to create the full URL
      let qrUrl = `${config.baseUrl}/car/${this.toolGroup.id}`;
      return qrUrl;
    },
    filteredTableColumns() {
      return this.tableColumns.filter(column => column.vIf ? column.vIf() : true);
    },
    filteredServiceHistoryColumns() {
      return this.serviceHistoryColumns.filter(column => column.vIf ? column.vIf() : true);
    },
    // Vehicle fields and customer-defined fields that have a value, as label/value rows
    vehicleDetails() {
      const car = this.toolGroup;
      const details = [];
      const add = (label, value) => {
        if (value !== '' && value !== null && value !== undefined) details.push({ label, value });
      };
      add(this.$t('cars.category'), car.vehicleCategory ? this.$t(labelKeyFor(VEHICLE_CATEGORIES, car.vehicleCategory)) : '');
      add(this.$t('cars.fuelType'), car.fuelType ? this.$t(labelKeyFor(FUEL_TYPES, car.fuelType)) : '');
      add(this.$t('cars.registrationDate'), formatDate(car.registrationDate));
      add(this.$t('cars.lastInspection'), formatDate(car.lastInspectionDate));
      add(this.$t('cars.nextInspection'), formatDate(car.nextInspectionDate));
      if (car.odometerKm != null) {
        const km = `${car.odometerKm.toLocaleString()} km`;
        add(this.$t('cars.odometerKm'), car.odometerDate ? `${km} (${formatDate(car.odometerDate)})` : km);
      }
      add(this.$t('cars.seats'), car.seats);
      if (car.isVatVehicle) add(this.$t('cars.isVatVehicle'), this.$t('common.yes'));
      add(this.$t('cars.comment'), car.comment);
      this.customFields.forEach(field => {
        let value = customFieldValue(car.toolGroupProperties, field);
        if (field.fieldType === CUSTOM_FIELD_TYPE.DATE) {
          value = formatDate(value);
        } else if (field.fieldType === CUSTOM_FIELD_TYPE.YES_NO) {
          value = value === 'true' ? this.$t('common.yes') : value === 'false' ? this.$t('common.no') : '';
        }
        add(field.name, value);
      });
      return details;
    },
  },
  created() {
    this.toolGroupId = this.$route.params.toolGroupId
    const token = Cookies.get('accessToken');
    const decodedToken = jwtDecode(token);
    this.userRole = decodedToken.role
    this.currentUserId = decodedToken.UserIdentifier
    this.fetchData();
    getCustomerConfig('EnableQRScanForCarToolAssignment').then(config => {
      this.enableQRScanForCarToolAssignment = config === true;
    });
    getCustomerConfig('AllowUsersToAddRemoveCarTools').then(config => {
      this.allowUsersToAddRemoveCarTools = config === true;
    });
    getCustomerConfig('AllowAssignedUsersToEditVehicles').then(config => {
      this.allowAssignedUsersToEditVehicles = config === true;
    });
    getCustomerConfig('EnableGPS').then(config => {
      this.enableGPS = config === true;
    });
    api.get(`/ToolGroupCustomField?toolGroupTypeId=${CAR_TOOL_GROUP_TYPE_ID}`)
      .then(response => {
        this.customFields = response.data;
      })
      .catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
      });
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    },
      async saveLastServiceDetails(){
        let requestBody = {
          properties: [{key:'carService' + this.generateGUID(), value: this.lastService + '|' + this.comment}]
        };
        try {
          await api.put(`/ToolGroup/${this.toolGroupId}`, requestBody);
          this.$toast.success(this.$t('common.updated'));
          this.showLastServiceModal = false;
          // Adding a new item to the array
          let newDate = new Date(this.lastService).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          })
          this.serviceHistory.push({ date: newDate, comment: this.comment });
          this.serviceHistory.sort((a, b) => this.parseDate(b.date) - this.parseDate(a.date));
  
          this.comment = ''
          this.lastService = ''
        } catch (error) {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(this.$t('common.unableToUpdate'), { timeout: 0 });
          this.showLastServiceModal = false;
        }
      },
      openLastServiceModal(){
        this.showLastServiceModal = true
      },
      openEditForm() {
        this.showEditForm = true;
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
      },
      onCarSaved() {
        this.showEditForm = false;
        this.fetchData();
      },
      printQRCode() {
      if (this.isMobile) {
        return;
      }

      const pageWidth = '3in';
      const pageHeight = '2in';
      const qrSize = '1.7in';
      const logoWidth = '1.5in';
      const logoHeight = '0.4in';
      const fontSize = '0.15in';
      const padding = '0.03in';
      const logoMarginBottom = '0.03in';

      const truncatedName = this.toolGroup.name.length > 20
        ? this.toolGroup.name.substring(0, 17) + '...'
        : this.toolGroup.name;

      const logoSrc = window.location.origin + '/img/sidebar-header-tolspor2.png';

      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              @page {
                size: ${pageWidth} ${pageHeight};
                margin: 0;
              }
              body, html {
                margin: 0;
                padding: 0;
                width: ${pageWidth};
                height: ${pageHeight};
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
              }
              .qr-print-container {
                width: ${pageWidth};
                height: ${pageHeight};
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                background: #ffffff;
                box-sizing: border-box;
                padding: ${padding};
              }
              .print-logo {
                width: ${logoWidth};
                height: auto;
                max-height: ${logoHeight};
                margin-bottom: ${logoMarginBottom};
                display: block;
                object-fit: contain;
              }
              .qrcode-vue {
                width: ${qrSize};
                height: ${qrSize};
                max-width: ${qrSize};
                max-height: ${qrSize};
                object-fit: contain;
              }
              h3 {
                color: black;
                font-weight: bold;
                font-size: ${fontSize};
                margin: 0;
                text-align: center;
                max-width: calc(${pageWidth} - ${padding} * 2);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            </style>
          </head>
          <body>
            <div class="qr-print-container">
              <img src="${logoSrc}" alt="app-logo" class="print-logo"/>
              <svg class="qrcode-vue" width="${qrSize}" height="${qrSize}" viewBox="${this.$refs.printqrcode.$el.getAttribute('viewBox')}">${this.$refs.printqrcode.$el.innerHTML}</svg>
              <h3>${truncatedName}</h3>
            </div>
            <script>
              var img = document.querySelector('.print-logo');
              function doPrint() { window.focus(); window.print(); }
              if (img.complete) { doPrint(); } else { img.onload = doPrint; img.onerror = doPrint; }
              window.addEventListener('afterprint', function() { window.close(); });
            <` + `/script>
          </body>
        </html>
      `);
      printWindow.document.close();
    },
      tableRowClassName({ row }) {
        if (row.toolReservations && row.toolReservations.length > 0) {
          return 'red-row'; // This is the name of the CSS class you want to apply
        }
        return '';
      },
      parseDate(dateString){
        const [day, month, year] = dateString.split('/').map(Number);
        return new Date(year, month - 1, day); // month is zero-indexed
      },
      fetchData()
      {
        this.tools = [];
        let toolGroupUrl = `/ToolGroup/${this.toolGroupId}`;
        api.get(toolGroupUrl)
            .then(response => {
              this.toolGroup = response.data;
              if(this.toolGroup.toolToToolGroups && this.toolGroup.toolToToolGroups.length > 0){
                this.tools = this.toolGroup.toolToToolGroups.map(item => {
                  return {
                    ...item.tool,
                    customerToolId: `#${item.tool.customerToolId}`
                  };
                });
              }
  
              if(this.toolGroup.toolGroupReservations.filter(p => p.isReserved === true) && this.toolGroup.toolGroupReservations.filter(p => p.isReserved === true).length > 0)
              {
                  this.reservedBy = this.toolGroup.toolGroupReservations.filter(p => p.isReserved === true)[0].user.firstName + ' ' + this.toolGroup.toolGroupReservations.filter(p => p.isReserved === true)[0].user.lastName
              }
              else{
                this.reservedBy = ''
              }
              if(this.toolGroup.toolGroupProperties.filter(p => p.key === 'licencePlate'))
              {
                this.licencePlate = this.toolGroup.toolGroupProperties.filter(p => p.key === 'licencePlate')[0].value
              }
  
              if(this.toolGroup.toolGroupProperties.filter(p => p.key.startsWith('carService'))
              && this.toolGroup.toolGroupProperties.filter(p => p.key.startsWith('carService')).length > 0)
              {
                this.serviceHistory = this.toolGroup.toolGroupProperties
                  .filter(p => p.key.startsWith('carService'))
                  .map(prop => {
                    const [date, comment] = prop.value.split("|");
                    return { date, comment };
                  })
                  .sort((a, b) => new Date(b.date) - new Date(a.date)) // Sort before formatting
                  .map(item => {
                    // Format date to DD/MM/YYYY
                    const formattedDate = new Date(item.date).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric'
                    });
                    return { date: formattedDate, comment: item.comment };
                  });
  
  
              }
            })
            .catch(error => {
              console.error('API request error:', error); // eslint-disable-line no-console
              this.$toast.error(this.$t('common.unableToRetrieveData'), { timeout: 0 });
            });
      },
      generateGUID() {
        // Helper function to generate a random GUID
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      async removeTool(id)
      {
          const result = await swal.fire({
          title: this.$t('cars.areYouSureRemove'),
          icon: 'warning',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-success btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
          },
          confirmButtonText: this.$t('cars.yesRemoveIt'),
          cancelButtonText: this.$t('delete.cancel'),
          buttonsStyling: false
        });
        if (result.isConfirmed) {
          try {
            await api.put('/ToolGroup/RemoveTool', {
              toolGroupId: this.toolGroupId,
              toolId: id
            });
            this.fetchData();
            await swal.fire({
              title: this.$t('cars.removedFromCar'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-success btn-fill',
              },
              buttonsStyling: false
            });
          } catch (error) {
            console.error('API request error:', error); // eslint-disable-line no-console
            this.$toast.error(this.$t('common.unableToUpdate'), { timeout: 0 });
          }
        }
      },
      async unreserve()
      {
        const result = await swal.fire({
          title: this.$t('cars.areYouSureReturn'),
          icon: 'warning',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-success btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
          },
          confirmButtonText: this.$t('cars.yesReturnIt'),
          cancelButtonText: this.$t('delete.cancel'),
          buttonsStyling: false
        });
        if (result.isConfirmed) {
          try {
            await api.put(`/ToolGroup/Unreserve/${this.toolGroupId}`);
            this.fetchData();
            await swal.fire({
              title: this.$t('cars.returned'),
              text: `${this.$t('cars.youReturned')} ${this.toolGroup.name}`,
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-success btn-fill',
              },
              buttonsStyling: false
            });
          } catch (error) {
            console.error('API request error:', error); // eslint-disable-line no-console
            this.$toast.error(this.$t('common.unableToUpdate'), { timeout: 0 });
          }
        }
      },
      navigateToTool(row) {
        this.$router.push({ name: 'Tool', params: { toolId: row.id } });
      },
      navigateToUserProfile(userId) {
        this.$router.push({ name: 'User', params: { userId: userId } });
      },
      openReserveUserTable()
      {
      this.showReserveTable = true;
      },
      closeReserveUserTable()
      {
      this.showReserveTable = false;
      },
      openAddToolTable()
      {
      this.showAddToolTable = true;
      },
      closeAddToolTable()
      {
      this.showAddToolTable = false;
      },
      openCarScanner() {
        this.$refs.carQrScanner.openScanner();
      },
      async openGpsDeviceModal() {
        this.deviceIdInput = this.toolGroup.deviceId || '';
        this.deviceTypeOption = this.toolGroup.deviceTypeId || null;
        if (this.deviceTypeOptions.length === 0) {
          try {
            const response = await api.get('/DeviceType');
            this.deviceTypeOptions = response.data;
          } catch (error) {
            console.error('API request error:', error); // eslint-disable-line no-console
            this.$toast.error(this.$t('common.unableToRetrieveData'), { timeout: 0 });
            return;
          }
        }
        this.showGpsDeviceModal = true;
      },
      async saveGpsDevice() {
        const trimmedId = (this.deviceIdInput || '').trim();
        if (trimmedId !== '' && this.deviceTypeOption == null) {
          this.$toast.info(this.$t('tools.selectDeviceType'), { timeout: 2000 });
          return;
        }
        try {
          await api.put(`/ToolGroup/${this.toolGroupId}`, {
            updateDevice: true,
            deviceId: trimmedId === '' ? null : trimmedId,
            deviceTypeId: trimmedId === '' ? null : this.deviceTypeOption,
          });
          this.$toast.success(this.$t('common.updated'), { timeout: 1500 });
          this.showGpsDeviceModal = false;
          this.fetchData();
        } catch (error) {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(this.$t('common.unableToUpdate'), { timeout: 0 });
        }
      },
      goToGeoTraces() {
        this.$router.push({ name: 'Car GeoTraces', params: { toolGroupId: this.toolGroupId } });
      },
      async onQrDecoded(qrContent) {
        const toolId = qrContent.split('/').pop();
        const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        if (!uuidRegex.test(toolId)) {
          this.$toast.error(this.$t('tools.invalidToolId'), { timeout: 2000 });
          return;
        }
        try {
          const infoResponse = await api.get(`/Tool/Info/${toolId}`);
          const info = infoResponse.data;
          if (info.invalidToolStatus === true) {
            this.$toast.error(this.$t('errors.canNotReserveToolInInvalidStatus'), { timeout: 0 });
            return;
          }
          if (info.isInToolGroup === true) {
            const result = await swal.fire({
              title: this.$t('tools.toolIsInCar') + ' ' + info.toolGroupName,
              text: this.$t('cars.doYouWantToMoveToThisCar'),
              icon: 'warning',
              showCancelButton: true,
              customClass: {
                confirmButton: 'btn btn-success btn-fill',
                cancelButton: 'btn btn-danger btn-fill'
              },
              confirmButtonText: this.$t('common.submit'),
              cancelButtonText: this.$t('delete.cancel'),
              buttonsStyling: false
            });
            if (!result.isConfirmed) return;
          }
          await api.put('/ToolGroup/AddTool', {
            toolGroupId: this.toolGroupId,
            toolId: toolId
          });
          this.$toast.success(this.$t('cars.toolAdded'), { timeout: 1500 });
          this.fetchData();
        } catch (error) {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(this.$t('common.unableToUpdate'), { timeout: 0 });
        }
      },

  },
  };
  </script>
  <style scoped>
  /* Fill the column so the history card matches the info card's height (Card adds 20px margins). */
  .stretch-card {
    height: calc(100% - 40px);
  }
  .red-row {
    background-color: rgb(214, 123, 123)!important;
  }
  .remove-tool-icon {
    color: red;
    font-size: 24px;
    cursor: pointer;
    transition: transform 0.15s ease;
  }
  .remove-tool-icon:hover {
    transform: scale(1.2);
  }
  .clickable-rows :deep(.el-table__row) {
  cursor: pointer;
}
.clickable-link {
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
  }
  .clickable-link:hover {
    color: #0056b3;
  }
  .qr-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .qr-print-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  @media print {
    h3 {
      color: black !important; /* Force the text color to be black when printed */
      font-weight: bold !important; /* Force the font weight to be bold when printed */
    }
    .qr-print-container {
      width: 100%;
      height: 50vh;
      position: fixed;
      top: 0;
      left: 0;
    }
  
    .qrcode-vue {
      width: 100%;
      height: auto;
    }
    .print-logo
    {
      width: 256px;
      padding-bottom: 10px;
    }
  }

  .black {
  color: black;
  }

  .blue {
    color: blue;
  }

  .orange {
    color: orange;
  }

  .red {
    color: red;
  }

  .green {
    color: green;
  }

  .material-icons {
    cursor: pointer;
  }

  .nav-item {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .navbar-nav .nav-item.dropdown .dropdown-toggle.btn.btn-primary.btn-block {
    background-color: #0275d8; /* Bootstrap primary blue */
    border-color: #0275d8;
    color: white; /* Ensure text is visible */
    width: 100%; /* Full row width */
    text-align: center; /* Center text */
    padding: 0.5rem 1rem; /* Adjust padding for button-like feel */
  }
  .dropdown-menu {
    min-width: 100%; /* Make menu full width like button */
    transform: translateX(0) !important; /* Override any transforms */
  }
  .dropdown-item {
    display: flex;
    align-items: center; /* Align icons and text vertically */
    padding: 0.5rem 1rem; /* Standard Bootstrap padding */
  }
  .dropdown-item i {
    font-size: 1.25rem; /* Slightly larger icons for visibility */
    margin-right: 0.5rem; /* Space between icon and text */
  }

  .dropdown-toggle::after {
    display: none !important;  /* Hide Bootstrap's default arrow/box */
  }
  </style>